<template>
  <div class="accordion-wrap">
    <div class="accordion">
      <div v-for="(item, index) in items" :key="index" class="accordion-item">
        <div class="accordion-header" @mouseover="showAccordion(index)" @click="toggleAccordion(index)">
          <div :class="{ active: openedIndex == index }">{{ item.title }}</div>
          <i class="el-icon-arrow-down" style="color:#2372E9;font-size:20px;" v-if="openedIndex === index"></i>
          <i class="el-icon-arrow-right" style="font-size:20px;" v-else></i>
        </div>
        <div class="accordion-content" v-show="openedIndex === index">
          <div>
            {{ item.content }}
            <img class="mobile-img" :src="item.imageUrl" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="img-block">
      <img :src="items[openedIndex].imageUrl" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          imageUrl: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/profile_img1.png",
          title: "我们是谁",
          content:
            "焱图慧云（苏州）信息科技有限公司是一家以无人机感知空间信息与人工智能融合技术为基础、赋能行业低空场景应用的创新型科技公司，是大疆深度生态应用合作伙伴。已获国家高新技术企业、苏州姑苏领军人才企业，苏州高新区领军人才企业，国家双软认证企业等资质荣誉。 焱图慧云整合人工智能、3S、云计算等前沿技术，以卫星无人机为载体，面向行业提供数据采集、处理分析及云计算服务，致力于为光伏、风电、自然资源、勘察设计、应急等行业提供领先的无人机应用产品和标准解决方案。",
        },
        {
          imageUrl: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/profile_img2.png",
          title: "我们能提供什么",
          content:
            "我们主要以无人机+焱图云平台为依托，向新能源行业提供光、储项目评估，风、光、线巡检场景等应用服务；另外，依托低空基础设施一站式服务，可提供执法巡查、河道巡检、森林防火等应用场景的行业赋能。以全新的服务模式，颠覆行业传统作业形态，实现项目安全运营及降本增效。",
        },
        {
          imageUrl: "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/about/profile_img3.png",
          title: "我们的目标",
          content:
            "在光伏、风电等领域提供行业内先进的无人机应用产品和标准化的解决方案，为客户实现降本增效!",
        },
      ],
      openedIndex: 0,
    };
  },
  methods: {
    toggleAccordion(index) {
      if (this.openedIndex === index) {
        this.openedIndex = null;
      } else {
        this.openedIndex = index;
      }
    },
    showAccordion(index) {
      this.openedIndex = index;
    },
    closeAccordion() {
      this.openedIndex = null;
    },
  },
};
</script>

<style lang="stylus" scoped>
.accordion-wrap {
    display:flex;
    width:100%;
    margin: 0 auto;
.accordion {
    margin-right:2rem;
    flex:1;
  .active {
      color:#2372E9;
  }
  .accordion-item {
  border-radius: 4px;
  margin-bottom: 15px;
  .accordion-header {
  cursor: pointer;
  color:#333;
  display: flex;
  font-weight:bold;
  font-size:2rem;
  height:3.125rem;
  line-height:3.125rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom:0.625rem;
}
.accordion-content {
  font-size:1rem;
  color:#666;
  .mobile-img {
    display:none;
  }
}
.accordion-content div{
  padding-bottom:1.25rem;
  color:#666;
  letter-spacing: 1px;
}

.accordion-icon {
  font-size: 20px;
  transition: transform 0.3s;
}
}
}
.img-block {
    flex:1;
}
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .accordion-wrap {
    padding:0 15px;
    .accordion {
      min-width:350px
    }
     .img-block {
      width:145px;
     }
  }
}
@media only screen and (max-width: 768px) {
  .accordion-wrap {
    padding:0 15px;
    .accordion {
      min-width:335px;
      .accordion-header {
        font-size:22px !important;
      }
      .accordion-content {
        font-size:14px !important;
      }
      .accordion-item {
        margin-bottom:0px !important;
      }
    }
     .img-block {
      display:none;      
     }
    .mobile-img {
    display:block !important;
    height:180px;
    margin-top:10px;
  }
  }
}
</style>
